import { render, staticRenderFns } from "./TwilioIntegration.vue?vue&type=template&id=d37e3cf8&"
import script from "./TwilioIntegration.vue?vue&type=script&lang=js&"
export * from "./TwilioIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports